export const eventsConst = {
  LOADED: 'EVENTS_LOADED',
  UNLOADED: 'EVENTS_UNLOADED',
  PATCH: 'EVENTS_PATCH'
};
